import config from 'config';

const getLogoSrc = (fieldId: string): string => `${config.api.host}/file/download-logo/?fileId=${fieldId}`;

export default getLogoSrc;
